import { createRouter, createWebHistory } from 'vue-router';

export const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    { path: '/', redirect: '/dashboard' },
    { path: '/dashboard', name: 'dashboard', component: () => import('./pages/DashboardPage.vue') },
    { path: '/players', name: 'players', component: () => import('./pages/PlayersPage.vue') },
    { path: '/players/:id', name: 'player-detail', component: () => import('./pages/PlayerDetailPage.vue') },
    { path: '/areas', name: 'areas', component: () => import('./pages/AreasPage.vue') },
    { path: '/areas/:id', name: 'area-detail', component: () => import('./pages/AreaDetailPage.vue') },
    { path: '/playlists', name: 'playlists', component: () => import('./pages/PlaylistsPage.vue') },
    { path: '/playlists/:name', name: 'playlist-detail', component: () => import('./pages/PlaylistDetailPage.vue') },
    { path: '/assets', name: 'assets', component: () => import('./pages/AssetsPage.vue') },
    { path: '/assets/builder', name: 'asset-builder', component: () => import('./pages/AssetBuilderPage.vue') },
    { path: '/labels', name: 'labels', component: () => import('./pages/LabelsPage.vue') },
    { path: '/licenses', name: 'licenses', component: () => import('./pages/LicensesPage.vue') },
    { path: '/settings', name: 'settings', component: () => import('./pages/SettingsPage.vue') },
  ],
});
